import * as Types from './ActionTypes';
import * as AdminServices from '../../../services/AdminServices';

export const getProductsInStock = (products) => {
    return {type: Types.GET_PRODUCTS_IN_STOCK, payload: products};
};

export const getMonthlyReport = (products) => {
    return { type: Types.GET_MONTHLY_REPORT, payload: products };
};

export const getProductsByCustomer = (productsByCustomer) => {
    return { type: Types.GET_ALL_PRODUCTS_BY_CUSTOMER, payload: productsByCustomer };
};

export const getSupplierAndProducts = (supplierAndProducts) => {
    return { type: Types.GET_ALL_SUPPLIER_AND_PRODUCTS, payload: supplierAndProducts };
};

export const checkProductInStock = (status) => {
    return { type: Types.CHECK_PRODUCT_IN_STOCK, payload: status };
};

export const checkStock = (status) => {
    return { type: Types.CHECK_STOCK, payload: status };
};

export const clearStateAction = () => {
    return { type: Types.CLEAR_STATE, payload: [] };
};


export const getProductsInStockAction = () => (
    (dispatch) => {
        return AdminServices.getProducts()
            .then((products) => {
                dispatch(getProductsInStock(products));
            })
            .catch(error => console.log(error));
    }
);

export const getMonthlyReportAction = (startDate, endDate) => (
    (dispatch) => {
        return AdminServices.getMonthlyReport(startDate, endDate)
            .then(products => {
                dispatch(getMonthlyReport(products));
            })
            .catch(error => console.log(error));
    }
);

export const getProductsByCustomerAction = (customerId) => (
    (dispatch) => {
        return AdminServices.getProductsByCustomer(customerId)
            .then(productsByCustomer => {
                dispatch(getProductsByCustomer(productsByCustomer));
            })
            .catch(error => console.log(error));
    }
);

export const getSupplierAndProductsAction = () => (
    (dispatch) => {
        return AdminServices.getSuppliersAndProducts()
            .then(supplierAndProducts => {
                dispatch(getSupplierAndProducts(supplierAndProducts));
            })
            .catch(error => console.log(error));
    }
);

export const checkProductInStockAction = (productId, quantity) => (
    (dispatch) => {
        return AdminServices.checkProductInStock(productId, quantity)
            .then(status => {
                dispatch(checkProductInStock(status));
            })
            .catch(error => console.log(error));
    }
);

export const checkStockAction = () => (
    (dispatch) => {
        return AdminServices.checkStock()
            .then(status => {
                dispatch(checkStock(status));
            })
            .catch(error => console.log(error));
    }
);
